import useAsyncData from "../../../../hooks/use-async-data";
import driverService from "../../driver.service";
import DriverContractsList from "./driver-contracts-list";
import DriverContractsListParams from "./driver-contracts-list-params";

const useDriverContractsList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<DriverContractsList | null>(null);

  const load = async (
    params: DriverContractsListParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const driverContractsList = await driverService.getDriverContractsList(
        params,
        signal,
      );

      setData(driverContractsList);
      setIsLoading(false);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useDriverContractsList;
